import React from "react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router";
import axios from "axios";
import "./SearchInterviews.css";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Interview from "./cards/Interview";
import Share from "./popups/Share";
import { Helmet } from "react-helmet";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Navbarlogedin from "./Navbarlogedin";
import Card from "./cards/Card";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const changeLink = () => {
  const links = document.querySelectorAll(".nav-item a p");
  links.forEach((link) => {
    if (link.classList.contains("active")) {
      link.classList.remove("active");
    }
    if (link.innerHTML === "Find an Interviewer") {
      // console.log(link);
      link.classList.add("active");
    }
  });
};

const SearchInterviews = () => {
  const mnc = [
    "Wal-Mart Stores",
    "Exxon Mobil",
    "Chevron",
    "Berkshire Hathaway",
    "Apple",
    "Phillips 66",
    "General Motors",
    "Ford Motor",
    "General Electric",
    "Valero Energy",
    "AT&T",
    "CVS Caremark",
    "Fannie Mae",
    "UnitedHealth Group",
    "McKesson",
  ];

  function getStyles(name, profile, theme) {
    return {
      fontWeight:
        profile.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const theme = useTheme();

  const [profile, setProfile] = React.useState([
    "Data Science",
    "Software",
    "Banking and Finance",
  ]);

  // if (user.profile) {
  //   setProfile(user.profile);
  // }
  const handlePrefChange = (event) => {
    const {
      target: { value },
    } = event;
    setProfile(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  const handleDelete = (label) => {
    setProfile(
      profile.filter(function (item) {
        return item !== label;
      })
    );
  };

  const [comp, setComp] = useState("");
  const handleSelectChange = (event) => {
    const {
      target: { value },
    } = event;
    setComp(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const [margin, setMargin] = useState("0px");

  window.addEventListener("load", function () {
    const clientHeight = document.querySelector(".search-result").clientHeight;
    const filterHeight = document.querySelector(".search-pref").clientHeight;
    console.log(
      "clientHeight: ",
      clientHeight,
      " filterHeight: ",
      filterHeight
    );
    setMargin(clientHeight - filterHeight + "px");
    console.log("diff: ", margin);
    var footer = document.getElementById("footer").getBoundingClientRect();
    console.log("footerHeight: ", footer.top);
  });

  var prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;
    // console.log(currentScrollPos);
    if (currentScrollPos >= 165 && currentScrollPos < 795) {
      // console.log(document.querySelector(".search-pref").classList);
      // console.log("stuck");
      document.querySelector(".search-pref").classList.add("static");
      document.querySelector(".search-pref").classList.remove("static-a");
    } else if (currentScrollPos >= 795) {
      // console.log("working");
      document.querySelector(".search-pref").classList.remove("static");
      document.querySelector(".search-pref").classList.add("static-a");
      // document.querySelector(".search-pref").style.marginTop = margin;
      // document.querySelector(".search-pref").style.marginTop = footer.top;
    } else {
      // console.log("not");
      document.querySelector(".search-pref").classList.remove("static");
      document.querySelector(".search-pref").classList.remove("static-a");
    }
    // prevScrollpos = currentScrollPos;
  };

  const [cards, setCards] = React.useState();
  useEffect(() => {
    async function fetchData() {
      const req = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/send/interviewersdemo`
      );
      setCards(req.data);
      console.log(cards);
    }
    fetchData();
  }, []);
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  useEffect(() => {
    changeLink();
  }, []);

  const [isHidden, setIsHidden] = useState(true);
  const [search, setSearch] = useState("");
  const [shareurl, setShareurl] = useState("www.youtube.co.in");
  return (
    <>
      <Helmet>
        <title>Interwiu | Home</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <Navbarlogedin />
      <Share url={shareurl} />
      <div className="searching">
        <h2
          className="font-[500] border-2 border-black drop-shadow-md"
          style={{ fontSize: "28px" }}
        >
          Find an Interviewer of your choice for a Mock Interview with Feedback
          Session
        </h2>

        <div className="searching-cont clearfix">
          <div className="search-pref box-shadow-request-card">
            <div
              className="w-auto text-lg px-2 py-1 border-2 rounded bg-white flex justify-between"
              id="searchbar-input"
            >
              <input
                type="text"
                className="mx-1 py-2 outline-none w-auto"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                name="search"
                id="search"
                placeholder="Search Interviewer by Name"
              />
              <div
                className="text-2xl w-auto cursor-pointer hover:text-sky-200"
                id="search-bar"
              >
                <i className="fa-solid fa-magnifying-glass"></i>
              </div>
            </div>
            <h4 className="text-center my-2 text-sky-600 text-xl">
              Filters <i className="fa-solid fa-filter"></i>
            </h4>
            <form>
              <div className="my-3">
                <div className="">
                  <div className="w-full rounded p-2">
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {profile.map((value) => (
                        <Chip
                          key={value}
                          label={value}
                          onDelete={() => {
                            handleDelete(value);
                          }}
                        />
                      ))}
                    </Box>
                  </div>
                  <Select
                    multiple
                    displayEmpty
                    required
                    value={profile}
                    sx={{ width: 1 }}
                    renderValue={() => "Profile Preference(s)"}
                    onChange={handlePrefChange}
                    MenuProps={MenuProps}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="Data Science">Data Science</MenuItem>
                    <MenuItem value="Software">Software</MenuItem>
                    <MenuItem value="Banking and Finance">
                      Banking and Finance
                    </MenuItem>
                    <MenuItem value="Consulting">Consulting</MenuItem>
                    <MenuItem value="Analytics">Analytics</MenuItem>
                    <MenuItem value="Product Management">
                      Product Management
                    </MenuItem>
                  </Select>
                </div>
              </div>
              {/* <div className="my-3">
                <InputLabel id="company">
                  <em>Company of the Interviewer</em>
                </InputLabel>
                <Select
                  displayEmpty
                  labelId="company"
                  value={comp}
                  onChange={handleSelectChange}
                  sx={{ width: 1 }}
                  MenuProps={MenuProps}
                  renderValue={comp !== "" ? undefined : () => "Select Company"}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value="none">
                    <em>None</em>
                  </MenuItem>
                  {mnc.map((name) => (
                    <MenuItem
                      key={name}
                      value={name}
                      style={getStyles(name, profile, theme)}
                    >
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </div> */}
              <div className="my-3">
                <p className="text-justify text-lg text-green-800 font-medium">
                  Do you want to specify your Scheduling Preferences for this
                  mock interview (with feedback) session?
                </p>
                <div className="element-item">
                  <input type="checkbox" name="preference" id="preference" />
                  <label htmlFor="preference"> No Specific Preferences</label>
                </div>
                <button
                  type="button"
                  className="cust-btn search-add-time-btn"
                  onClick={() => {
                    // const addPref = document.querySelector(".popup");
                    // addPref.classList.remove("hide");
                    setIsHidden((current) => !current);
                  }}
                  style={{ display: isHidden ? "" : "none" }}
                >
                  <span style={{ fontSize: "24px", margin: "5px 5px" }}>+</span>{" "}
                  Add Time Preference
                </button>
                <button
                  type="button"
                  className="cust-btn search-add-time-btn"
                  onClick={() => {
                    // const addPref = document.querySelector(".popup");
                    // addPref.classList.remove("hide");
                    setIsHidden((current) => !current);
                  }}
                  style={{
                    display: isHidden ? "none" : "",
                    marginBottom: "10px",
                  }}
                >
                  <span style={{ fontSize: "24px", margin: "5px 5px" }}>-</span>{" "}
                  Remove Time Preference
                </button>
                <div
                  className="date-time-filter"
                  style={{ display: isHidden ? "none" : "" }}
                >
                  {/* <DateTimePicker key={new Date().getTime()} /> */}
                </div>
              </div>
            </form>
          </div>
          <div className="search-result">
            <h3 className="text-xl font-[500]">
              Search results {cards ? cards.length : 0}
            </h3>
            <div className="search-result-cont">
              <Interview
                name="{result.name}"
                desg="{result.desg}"
                price="{result.price}"
                profile="{result.profile}"
                id="{result._id}"
                logo={require("../../images/amazon.png")}
                setShareUrl={setShareurl}
              />
              {cards?.map((result) => (
                <>
                  <Card
                    name={result.name}
                    desg={result.desg}
                    price={result.price}
                    profile={result.profile}
                    id={result._id}
                    logo={require("../../images/amazon.png")}
                    setShareUrl={setShareurl}
                  />
                  <Interview
                    desg={result.desg}
                    id={result.id}
                    logo={require("../../images/amazon.png")}
                    name={result.name}
                    price={result.price}
                    profile={result.profile}
                    setShareUrl={setShareurl}
                  />
                </>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchInterviews;
